const API_BASE = process.env.REACT_APP_API_BASE || '';

// 인증 토큰 가져오기
const getAuthToken = () => localStorage.getItem('auth_token');

// 공통 fetch 함수
async function apiFetch(endpoint, options = {}) {
  const token = getAuthToken();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = token;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'API request failed');
  }

  return response.json();
}

// 사용자 API
export const userAPI = {
  requestCode: (phone) =>
    apiFetch('/api/v1/user/code', {
      method: 'POST',
      body: JSON.stringify({ phone }),
    }),

  verifyCode: (phone, code) =>
    apiFetch('/api/v1/user/verify', {
      method: 'POST',
      body: JSON.stringify({ phone, code }),
    }),

  getProfile: () =>
    apiFetch('/api/v1/user/me'),

  updateProfile: (data) =>
    apiFetch('/api/v1/user/me', {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  submitB2BApplication: (data) =>
    apiFetch('/api/v1/user/b2b-application', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
};

// 상품 API
export const productAPI = {
  getList: () =>
    apiFetch('/api/v1/product/list'),

  getDetail: (uuid) =>
    apiFetch(`/api/v1/product/${uuid}`),
};

// 주문 API
export const orderAPI = {
  addToCart: (product_uuid, quantity, option_name = null) =>
    apiFetch('/api/v1/order/cart', {
      method: 'POST',
      body: JSON.stringify({ product_uuid, quantity, option_name }),
    }),

  getCart: () =>
    apiFetch('/api/v1/order/cart'),

  updateCartItem: (product_uuid, quantity, option_name = null) =>
    apiFetch('/api/v1/order/cart/item', {
      method: 'PUT',
      body: JSON.stringify({ product_uuid, quantity, option_name }),
    }),

  removeCartItem: (product_uuid, option_name = null) => {
    const params = option_name ? `?option_name=${encodeURIComponent(option_name)}` : '';
    return apiFetch(`/api/v1/order/cart/item/${product_uuid}${params}`, {
      method: 'DELETE',
    });
  },

  clearCart: () =>
    apiFetch('/api/v1/order/cart', {
      method: 'DELETE',
    }),

  checkout: (cart_uuid, address) =>
    apiFetch('/api/v1/order/checkout', {
      method: 'POST',
      body: JSON.stringify({ cart_uuid, address }),
    }),

  getOrders: () =>
    apiFetch('/api/v1/order/orders'),
};

// 관리자 API
export const adminAPI = {
  // 상품 관리
  getProducts: () =>
    apiFetch('/api/v1/admin/products'),

  createProduct: (productData) =>
    apiFetch('/api/v1/admin/product', {
      method: 'POST',
      body: JSON.stringify(productData),
    }),

  updateProduct: (uuid, productData) =>
    apiFetch(`/api/v1/admin/product/${uuid}`, {
      method: 'PATCH',
      body: JSON.stringify(productData),
    }),

  deleteProduct: (uuid) =>
    apiFetch(`/api/v1/admin/product/${uuid}`, {
      method: 'DELETE',
    }),

  // 이미지 업로드
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const token = getAuthToken();
    const response = await fetch(`${API_BASE}/api/v1/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': token,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Image upload failed');
    }

    return response.json();
  },

  // 주문 관리
  getOrders: () =>
    apiFetch('/api/v1/admin/orders'),

  updateOrderStatus: (uuid, status, trackingData) =>
    apiFetch(`/api/v1/admin/order/${uuid}`, {
      method: 'POST',
      body: JSON.stringify({ status, ...trackingData }),
    }),

  // 유저 관리
  getUsers: () =>
    apiFetch('/api/v1/admin/users'),

  updateUser: (phone, userData) =>
    apiFetch(`/api/v1/admin/user/${phone}`, {
      method: 'PATCH',
      body: JSON.stringify(userData),
    }),

  // 수동출고
  getFulfillmentProducts: () =>
    apiFetch('/api/v1/admin/fulfillment-products'),

  createManualShipment: (shipmentData) =>
    apiFetch('/api/v1/admin/manual-shipment', {
      method: 'POST',
      body: JSON.stringify(shipmentData),
    }),

  // SKU 관리
  getSkus: () =>
    apiFetch('/api/v1/admin/skus'),

  createSku: (skuData) =>
    apiFetch('/api/v1/admin/sku', {
      method: 'POST',
      body: JSON.stringify(skuData),
    }),

  updateSku: (skuId, skuData) =>
    apiFetch(`/api/v1/admin/sku/${skuId}`, {
      method: 'PATCH',
      body: JSON.stringify(skuData),
    }),

  deleteSku: (skuId) =>
    apiFetch(`/api/v1/admin/sku/${skuId}`, {
      method: 'DELETE',
    }),
};
